import { formatDate } from "../../../../../functions/dateTime/formatDate";

const CylinderDetails = ({ data }) => {
  const { cylinder } = data;

  // Utility: check if hydroTestingDate is older than 2 years
  const isOlderThan2Years = (() => {
    const testDate = new Date(cylinder.lastHydroTestingDate);
    const expiryDate = new Date(testDate);
    expiryDate.setFullYear(expiryDate.getFullYear() + 2);

    return new Date() > expiryDate;
  })();

  // Reusable Detail Row Component
  const DetailRow = ({ label, value, border = true }) => (
    <div
      className={`py-3 px-4 w-full text-xs lg:text-sm ${
        border ? "border-b-1 border-gray-300" : ""
      }`}
    >
      <p className="text-gray-500 tracking-widest">{label}</p>
      <p className="font-figtreeMedium tracking-wider">{value}</p>
    </div>
  );

  return (
    <div className="w-[25%] shadow-200 rounded-md text-light-black bg-[#4b3ba71c]">
      <h4 className="pl-4 py-3 max-lg:text-xs font-interBold border-b-1 border-gray-300">
        Cylinder Details
      </h4>

      <DetailRow label="NUMBER" value={cylinder.serialNumber} />
      <DetailRow label="SIZE" value={`${cylinder.size} KG`} />
      <DetailRow label="CURRENT STATION" value={`${cylinder.currentStation}`} />

      {/* Hydro Testing Date Row */}
      <div className="py-3 px-4 w-full text-sm">
        <p className="text-gray-500 text-xs lg:text-sm tracking-widest flex justify-between items-center">
          LAST HYDRO
          {cylinder.hydroTestingDate && (
            <span
              className={`tracking-normal rounded-full px-2 ${
                isOlderThan2Years
                  ? "text-red-600 bg-red-100"
                  : "text-green-3 bg-teal-100"
              }`}
            >
              {isOlderThan2Years ? "Expired" : "Valid"}
            </span>
          )}
        </p>
        <p className="font-figtree tracking-wide text-xs lg:text-smr">
          {formatDate(cylinder.hydroTestingDate)}
        </p>
      </div>
    </div>
  );
};

export default CylinderDetails;
